module.exports = __webpack_public_path__ + "static/media/compass.d887cf78.png";